import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./styles.module.scss";

const ChecklistItemsContainer = React.memo(({ className, children, ...props }) => (
  <div
    {...props}
    className={classNames(styles.checklistItemsContainer, className, {
      [styles.isEmpty]: React.Children.count(children) === 0,
    })}
    data-testid="checklist-items-container"
  >
    {children}
  </div>
));

ChecklistItemsContainer.propTypes = {
  className: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.node),
};

export default ChecklistItemsContainer;
